// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import IframeResizer from 'iframe-resizer-react';

// Components
import Container from '../../container/container';

// Styles
import SmartmatchSubmissionFormStyles from './smartmatchSubmissionForm.styles';

export default function SmartmatchSubmissionForm({ layout }) {
  const formName = layout?.submissionFormName;
  const formUrl = layout?.submissionFormUrl;

  const handleResized = () => {
    if (typeof document !== 'undefined') document.documentElement.scrollTop = 0;
  };

  return (
    <SmartmatchSubmissionFormStyles>
      <Container flex justifyContent="center">
        <IframeResizer
          src={formUrl}
          title={`${formName} form`}
          className="smartmatch-iframe"
          id="smartmatch-iframe"
          inPageLinks
          onResized={handleResized}
        />
      </Container>
    </SmartmatchSubmissionFormStyles>
  );
}

SmartmatchSubmissionForm.propTypes = {
  layout: PropTypes.shape({
    submissionFormName: PropTypes.string.isRequired,
    submissionFormUrl: PropTypes.string.isRequired,
  }),
};

SmartmatchSubmissionForm.defaultProps = {
  layout: {},
};
